<template>
  <div id="firebaseui-auth-container">
    <facebook-button @click="signInByFacebook" :disabled="loading"></facebook-button>
    <google-button @click="signInByGoogle" :disabled="loading"></google-button>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import { mapActions } from 'vuex';
import FacebookButton from '@/components/common/social/FacebookButton.vue';
import GoogleButton from '@/components/common/social/GoogleButton.vue';
import { SOCIAL_SIGN_IN } from '../../store/session/actionTypes';

export default {
  components: {
    FacebookButton,
    GoogleButton,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      socialSignIn: SOCIAL_SIGN_IN,
    }),
    async signInByFacebook() {
      try {
        this.loading = true;
        await this.signIn(new firebase.auth.FacebookAuthProvider());
      } finally {
        this.loading = false;
      }
    },
    async signInByGoogle() {
      try {
        this.loading = true;
        await this.signIn(new firebase.auth.GoogleAuthProvider());
      } finally {
        this.loading = false;
      }
    },
    async signIn(provider) {
      await this.socialSignIn(provider);
      this.$emit('success');
    },
  },
};
</script>

<style lang="scss">
@import '~@/assets/styles/breakpoints';

#firebaseui-auth-container {
  display: flex;
  flex: 1;
  justify-content: center;
}

.btn {
  margin: 10px;
}

@media (max-width: $login-base-breakpoint) {
  .btn {
    flex: 1;
  }

  .google-btn {
    margin-right: 0;
  }

  .facebook-btn {
    margin-left: 0;
  }
}
</style>
